import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import MoreOption from '@/components/common/more-option/MoreOption.vue';
import { FilterItem } from '@/models';
import { set } from 'lodash';

@Component({
  components: {
    MoreOption
  }
})
export default class FilterList extends Vue {
  @Prop({ default: [] }) items: FilterItem[];
  @Prop() name: string;

  private itemShown = [] as boolean[];
  private filterItems: FilterItem[] = [];
  private filterValues = {};

  get moreOptionItems(): boolean[] {
    return [...this.itemShown];
  }

  get itemsMoreOption(): FilterItem[] {
    return this.items;
  }

  @Watch('items', { deep: true })
  onItemChanged(): void {
    this.itemShown.forEach((shown, index) => {
      if (shown) {
        const { label, value } = this.items[index];
        const filterItemIndex = this.filterItems.findIndex(item => item.label === label);
        if (filterItemIndex !== null || filterItemIndex !== -1) {
          this.filterItems[filterItemIndex] = this.items[index];
          set(this.filterValues, label, value);
        }
      }
    });
  }

  onFilterValuesLocalStorageChanged(): void {
    const filterValuesLocalStorage = JSON.parse(localStorage.getItem(`${this.name}/filterValues`) as string) || {};
    this.$nextTick(() => {
      Object.keys(filterValuesLocalStorage).map(key => {
        const index = this.items.findIndex(({ label }) => label === key);
        if (index !== null || index !== -1) {
          return this.items[index].onInput(filterValuesLocalStorage[key]);
        }
      });
    });
  }

  isActiveItem(label: string): boolean {
    const foundItem = this.filterItems.find(item => {
      return item.label === label;
    });
    return !!foundItem;
  }

  mapFilterShown(itemShown: boolean[], isMounted?: boolean): void {
    if (isMounted) {
      itemShown.map((item, index) => item && this.filterItems.push(this.items[index]));
    } else {
      const shown = [...this.itemShown];
      for (let i = 0; i < shown.length; i++) {
        if (!shown[i] && itemShown[i]) {
          this.filterItems.push(this.items[i]);
        }

        if (shown[i] && !itemShown[i]) {
          const index = this.filterItems.findIndex(item => item.label === this.items[i].label);
          this.filterItems.splice(index, 1);
        }
      }
    }
  }

  onCheckboxChanged(itemShown: boolean[]): void {
    this.mapFilterShown(itemShown);

    this.itemShown = [...itemShown];

    this.itemShown.map((shown, index) => {
      if (!shown) {
        return this.items[index].onInput([]);
      }
    });
  }

  beforeUnmount(): void {
    localStorage.setItem(`${this.name}/filterValues`, JSON.stringify(this.filterValues));
    localStorage.setItem(`${this.name}/filter`, JSON.stringify(this.itemShown));
  }

  beforeReloadPage(): void {
    window.addEventListener('beforeunload', () => {
      this.beforeUnmount();
    });
  }

  mounted(): void {
    this.mapFilterShown(this.itemShown, true);
    this.onFilterValuesLocalStorageChanged();
  }

  created(): void {
    this.beforeReloadPage();
    const filterItem = JSON.parse(localStorage.getItem(`${this.$route.name}/filter`) as string) || [];

    if (filterItem.length > 0) {
      this.itemShown = [...filterItem];
    } else {
      this.itemShown = [...Array(this.items.length || 0).fill(false)];
    }
  }

  destroyed(): void {
    this.beforeUnmount();
  }
}
